import { Box, Button } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { initialBenefitsFetch } from "../permissions/benefits/redux/benefits.init";
import { createConnectSubscription } from "../utils";
import { LoaderComponent } from "./Loader";
import { EQueryKeys } from "./subscriptions/hooks/useMySubscriptionInfo.query";

// Renders errors or successfull transactions on the screen.
function Message({ content }) {
  return <p>{content}</p>;
}

export const PlanPaymentFree = ({ setSubscriptionState = () => { } }) => {
  const planState = useSelector((state) => state?.planState);
  const planSelected = planState?.planSelected ?? null;
  const backendSubscriptionId = planSelected?.subscriptionId;
  const [loading, setLoading] = useState(false);

  const [currentPlanId, setCurrentPlanId] = useState(planSelected?.id);
  const { showBoundary } = useErrorBoundary();

  const tokenLocal = sessionStorage.getItem("token");

  const [message, setMessage] = useState("");

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPlanId(planState.planSelected.id);
  }, [planState]);

  const handleCreateConnectSubscription = useCallback(
    async (currentSubscriptionId) => {
      try {
        setLoading(true);
        console.log(planState);
        const connectSubs = await createConnectSubscription(
          "free_trial", // provided by PayPal web, for example "free_trial"
          backendSubscriptionId,
          planSelected?.id,
          0, // subtotal
          planState?.planSelected?.discount ?? 0, // discount
          Number(planState?.planSelected?.price?.amount) - Number(planState?.planSelected?.discount ?? 0), // total
          tokenLocal,
        );

        return connectSubs;
      } catch (error) {
        // Propagate error so caller can handle it appropriately
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [planState],
  );

  const subscribe = async () => {
    try {
      const subsinfo = await handleCreateConnectSubscription("free_trial");

      // Verify that subscription was created successfully
      if (!subsinfo || !subsinfo?.subscription?.id) {
        setSubscriptionState({
          state: "error",
          data: {
            message: `Failed to create subscription in our system. Please contact support.`,
            subscriptionId: "free_trial_01",
            orderId: "free_trial_01",
          },
        });
        return;
      }

      setSubscriptionState({
        state: "success",
        data: {
          message: `You have successfully subscribed to the plan.`,
          subscriptionId: "free_trial_01",
          orderId: "free_trial_01",
          subscription: {
            id: subsinfo?.subscription?.id,
            paypalSubscriptionId: subsinfo?.subscription?.paypalId,
            planName: subsinfo?.subscription?.plan?.product?.name,
            planId: subsinfo?.subscription?.plan?.id,
            planPaypalId: subsinfo?.subscription?.plan?.paypalPlanId,
            hexColor: subsinfo?.subscription?.plan?.product?.hexColor,
            createdAt: subsinfo?.subscription?.createdAt,
          },
          benefits: subsinfo?.benefits ?? [],
        },
      });

      await queryClient.invalidateQueries({
        queryKey: [EQueryKeys.MY_SUBSCRIPTION_INFO],
      });

      dispatch(initialBenefitsFetch());
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Unknown error occurred";
      const errorStatus = error?.response?.status || error?.status || "Unknown";

      setSubscriptionState({
        state: "error",
        data: {
          message: `Failed to activate the subscription. Error: ${errorMessage} (Status: ${errorStatus}). Please contact support.`,
          subscriptionId: "free_trial_01",
          orderId: "free_trial_01",
          error: {
            message: errorMessage,
            status: errorStatus,
            details: error?.response?.data,
          },
        },
      });
    }
  };

  return (
    <div className="PlanPaymentFree">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            marginTop: "auto",
            marginBottom: "30px",
          }}
          //TODO: Plan Selected
          onClick={() => {
            subscribe();
          }}
        >
          CHOOSE PLAN
        </Button>
      </Box>
      <LoaderComponent open={loading} type="spinner"></LoaderComponent>
    </div>
  );
};
